jQuery(document).ready(function($) {
	
	// Hide the placeholder
	$('.youtube-video-placeholder').remove();
	
	// Build the embeds
	var div = $('.youtube-video');
	
	$.each(div, function() {
		
		var url = $(this).data('videourl'); 
		var videoTitle = $(this).data('videotitle'); 
		
		var args = [url, videoTitle];
		
		// Add the embedded video to the page
		$(this).append(formatVideo(args));
		
	});
	
	/*
	* Parse the YouTube URL to get the video ID only
	*
	* Updated 11/10/23 to include support for "shorts" urls.
	*
	* New regex reference: https://stackoverflow.com/questions/71000139/javascript-regex-for-youtube-video-and-shorts-id
	* 
	* https://www.youtube.com/watch?v=0zM3nApSvMg&feature=feedrec_grec_index
	* https://www.youtube.com/user/IngridMichaelsonVEVO#p/a/u/1/QdK8U-VIH_o
	* https://www.youtube.com/v/0zM3nApSvMg?fs=1&amp;hl=en_US&amp;rel=0
	* https://www.youtube.com/watch?v=0zM3nApSvMg#t=0m10s
	* https://www.youtube.com/embed/0zM3nApSvMg?rel=0
	* https://www.youtube.com/watch?v=0zM3nApSvMg
	* https://youtu.be/0zM3nApSvMg
	* https://youtube.com/shorts/0dPkkQeRwTI?feature=share
	* https://youtube.com/shorts/0dPkkQeRwTI
	*/
	function youtubeParser(url) {
		var regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
		var match = regex.exec(url);
		return match ? match[3] : false;
	}
	
	/**
	*	Formats the iframe for the embedded YouTube video
	*	
	*	@param array args		An array of all of the settings for the embedded video set by the user. 
	*	
	*	@return String frame 	The formatted iframe
	*/
	function formatVideo(args) {
		// Assign the args to individual variables
		var url = args[0]; 
		var videoTitle = args[1];
		
		// Get the video ID to add to the embed URL
		if (url != '' && url != null && url != undefined) {
			videoID = youtubeParser(url);
		}
		
		// Assign the values for the embed arguments. 
		if (videoTitle != '' && videoTitle != null && videoTitle != undefined) {
			videoTitle = 'YouTube video: ' + validator.escape(videoTitle);
		} else {
			videoTitle = 'YouTube video player';
		}
		
		// Set the iframe variables and assign it to the returned frame string
		var frame = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '?rel=0" title="' + videoTitle + '" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
		
		return frame;		
	}
	
});